import script from "./FooterMyPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterMyPage.vue?vue&type=script&lang=ts&setup=true"

import "./FooterMyPage.vue?vue&type=style&index=0&id=4e1d4bae&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1d4bae"]])

export default __exports__